import { render, staticRenderFns } from "./UpdateTemplate.vue?vue&type=template&id=d8de8074&scoped=true&"
import script from "./UpdateTemplate.vue?vue&type=script&lang=js&"
export * from "./UpdateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8de8074",
  null
  
)

export default component.exports